import { motion } from "framer-motion";
import { ArrowDown, ArrowRight } from "lucide-react";
import { OFFLINE_FLOW } from "../../data/content";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";
import { discussService } from "../../lib/scroll";

export const OfflineFlow = () => (
    <section data-testid="offline-flow-section" className="py-24 lg:py-32 relative overflow-hidden">
        <div
            className="absolute top-1/3 left-1/2 -translate-x-1/2 h-[26rem] w-[26rem] rounded-full bg-[#00E5FF]/6 blur-[120px]"
            aria-hidden="true"
        />
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto relative">
            <ChapterHeading
                label="Digital Transformation"
                title="Take Your Business From Offline to Online"
                sub="Your customers are already online. We help your business become easier to find, contact, trust and transact with."
                align="center"
            />

            <div className="max-w-xl mx-auto">
                {OFFLINE_FLOW.map((step, i) => (
                    <div key={step.label}>
                        <Reveal delay={i * 0.05}>
                            <motion.div
                                data-testid={`flow-step-${i}`}
                                whileHover={{ scale: 1.02 }}
                                className={`flex items-center gap-4 rounded-2xl border px-5 py-4 transition-colors duration-300 ${
                                    i === 0 || i === OFFLINE_FLOW.length - 1
                                        ? "border-[#F5C518]/40 bg-[#F5C518]/5"
                                        : "border-white/10 bg-[#0D131F]"
                                }`}
                            >
                                <span className="font-jbmono text-[10px] text-slate-500 w-6 shrink-0">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div
                                    className={`h-10 w-10 rounded-xl flex items-center justify-center shrink-0 border ${
                                        i === 0 || i === OFFLINE_FLOW.length - 1
                                            ? "bg-[#F5C518]/15 border-[#F5C518]/40"
                                            : "bg-[#00E5FF]/10 border-[#00E5FF]/25"
                                    }`}
                                >
                                    <step.icon
                                        size={18}
                                        className={
                                            i === 0 || i === OFFLINE_FLOW.length - 1
                                                ? "text-[#F5C518]"
                                                : "text-[#00E5FF]"
                                        }
                                    />
                                </div>
                                <span className="font-display font-semibold text-white text-base sm:text-lg tracking-wide">
                                    {step.label}
                                </span>
                            </motion.div>
                        </Reveal>
                        {i < OFFLINE_FLOW.length - 1 && (
                            <motion.div
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.15 }}
                                className="flex justify-center py-1.5"
                                aria-hidden="true"
                            >
                                <ArrowDown size={15} className="text-[#00E5FF]/50" />
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>

            <Reveal className="mt-12 text-center">
                <button
                    data-testid="flow-cta-digitize"
                    onClick={() => discussService("Complete Offline-to-Online Package")}
                    className="group inline-flex items-center gap-2 rounded-full bg-[#F5C518] px-8 py-4 text-sm sm:text-base font-semibold text-[#07090E] transition-all duration-300 hover:bg-[#E5B50F] hover:shadow-[0_0_36px_-6px_rgba(245,197,24,0.55)] active:scale-95"
                >
                    Digitize My Business
                    <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
                </button>
            </Reveal>
        </div>
    </section>
);
